// extracted by mini-css-extract-plugin
export var cartIcon = "_p2-0";
export var cartIconContainer = "_p2-1";